// NOTE: Custom polyfill since Safari doesn't support requestIdleCallback
export type IdleExecutionIdentifier = number | NodeJS.Timeout;

export function executeWhenIdle(
  callback: IdleRequestCallback,
  maxTimeout?: number
): IdleExecutionIdentifier {
  if (window.requestIdleCallback) {
    return window.requestIdleCallback(callback, { timeout: maxTimeout });
  }

  return setTimeout(
    () => callback({ didTimeout: false, timeRemaining: () => 0 }),
    0
  );
}

export function cancelIdleExecution(
  executionIdentifier: IdleExecutionIdentifier
): void {
  if (window.cancelIdleCallback && typeof executionIdentifier === 'number') {
    window.cancelIdleCallback(executionIdentifier);
  } else {
    clearTimeout(executionIdentifier);
  }
}
